import { render } from "./imprint-view-component.vue?vue&type=template&id=0689fb2f&scoped=true&ts=true"
import script from "./imprint-view-component.vue?vue&type=script&lang=ts"
export * from "./imprint-view-component.vue?vue&type=script&lang=ts"

import "./imprint-view-component.vue?vue&type=style&index=0&id=0689fb2f&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0689fb2f"]])

export default __exports__